import { render, staticRenderFns } from "./Tail.vue?vue&type=template&id=9927178c&scoped=true&lang=pug&"
import script from "./Tail.vue?vue&type=script&lang=ts&"
export * from "./Tail.vue?vue&type=script&lang=ts&"
import style0 from "./Tail.vue?vue&type=style&index=0&id=9927178c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9927178c",
  null
  
)

export default component.exports